import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  style: {
    "padding-top": "10px"
  }
};
var _hoisted_2 = {
  style: {
    "padding-top": "10px"
  }
};
var _hoisted_3 = {
  style: {
    "padding-top": "10px",
    "color": "#999"
  }
};
export default {
  __name: 'flowlist',
  props: {
    // 审核流转记录列表
    list: {
      type: Array,
      required: true,
      default: () => []
    },
    // 自定义字段 key 值
    nodeKey: {
      type: String,
      default: "node_name" // 默认审核节点字段
    },
    userKey: {
      type: String,
      default: "approver_user_name" // 默认审核人员字段
    },
    timeKey: {
      type: String,
      default: "created_at" // 默认审核时间字段
    },
    remarkKey: {
      type: String,
      default: "remark" // 默认审核备注字段
    }
  },
  setup(__props) {
    // 使用 defineProps 接收父组件传递的参数
    var props = __props;
    return (_ctx, _cache) => {
      var _props$list;
      var _component_el_card = _resolveComponent("el-card");
      var _component_el_timeline_item = _resolveComponent("el-timeline-item");
      var _component_el_timeline = _resolveComponent("el-timeline");
      return (_props$list = __props.list) !== null && _props$list !== void 0 && _props$list.length ? (_openBlock(), _createBlock(_component_el_timeline, {
        key: 0,
        style: {
          "width": "600px",
          "margin": "15px 0 0 50px",
          "text-align": "left"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
          var _props$list2;
          return _openBlock(), _createBlock(_component_el_timeline_item, {
            class: _normalizeClass([((_props$list2 = __props.list) === null || _props$list2 === void 0 ? void 0 : _props$list2.length) == 1 ? 's' : '']),
            center: "",
            timestamp: item.update_at,
            placement: "top",
            key: index,
            type: item.approval_status == 1 ? 'success' : 'danger'
          }, {
            default: _withCtx(() => [_createVNode(_component_el_card, null, {
              default: _withCtx(() => [_createElementVNode("h4", null, "审核节点：" + _toDisplayString(item[__props.nodeKey]), 1), _createElementVNode("h4", _hoisted_1, " 审核人员：" + _toDisplayString(item[__props.userKey]), 1), _createElementVNode("h4", _hoisted_2, "审核时间：" + _toDisplayString(item[__props.timeKey]), 1), _createElementVNode("p", _hoisted_3, " 审核备注：" + _toDisplayString(item[__props.remarkKey]), 1)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1032, ["class", "timestamp", "type"]);
        }), 128))]),
        _: 1
      })) : _createCommentVNode("", true);
    };
  }
};